var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWriteW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 20.75L4.49999 17L17 4.50005L19.4999 7.00004L6.99998 19.5L3.25 20.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2499 3.24984L17.8333 3.6665L20.3332 6.1665L20.7499 5.74984L20.75 5.74997C21.4404 5.05961 21.4404 3.94033 20.75 3.24997C20.0597 2.55962 18.9404 2.55962 18.25 3.24996L18.2499 3.24984Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWriteW);
export default __webpack_public_path__ + "static/media/icon_write_w.42ffeef94328443ddfe24f267bd3c2af.svg";
export { ForwardRef as ReactComponent };